export interface Workflow {
  id: number;
  name: string;
  status: 'errored' | 'finished' | 'processing' | 'waiting';
  tasks: WorkflowTask[];
}

export interface WorkflowTask {
  events: {
    content: any;
    createdAt: number;
    event: string;
    id: number;
  }[];
  id: number;
  identifier: string;
  result: any;
  status: 'waiting' | 'queued' | 'processing' | 'finished' | 'errored';
  subworkflows?: Workflow[];
}[];
